import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { FileDownloader } from "src/Components";
// Requests
import {
  getShortCoveredCallTable,
  getShortCoveredCallExcel,
} from "src/Requests/imePortfolio";
// Types
import {
  IShortCoveredCallSearchParams,
  IShortCoveredCallTableReport,
} from "src/Interfaces/imePortfolio";

const ShortCoveredCall: React.FC = () => {
  return (
    <div className="h-full w-full p-5">
      <FileDownloader getFile={getShortCoveredCallExcel} />
      <div className="w-full">
        <TableTemplate<
          IShortCoveredCallSearchParams,
          IShortCoveredCallTableReport
        >
          TableUI={({ reports, onAction, sortingType, setSortingType }) => {
            return (
              <CommonTableUI
                reports={reports}
                onAction={onAction}
                sortingType={sortingType}
                setSortingType={setSortingType}
                tableBoxClassName="max-h-[700px] overflow-auto"
              />
            );
          }}
          getDataTable={getShortCoveredCallTable}
          withSort
        />
      </div>
    </div>
  );
};

export default ShortCoveredCall;
